<template>
	<div class="link_index">
		<!-- 公共头部 -->
		<div class="per-line-40 black top-box">
			<div class="fl">歡迎來到香港中國企業協會</div>
			<div class="fr">
				<span v-if="$store.state.userName === ''">未登錄</span>
				<span v-else>歡迎 <span class="blue">{{ $store.state.userName }}</span> <span @click="exitAccount()" class="c">退出</span></span>
				<span class="c mar-lef-15" @click="goArticleDetail(2)">關於我們</span>
				<span @click="goArticleDetail(3)" class="mar-lef-15 c">聯系我們</span>
			</div>
		</div>
		<div class="pos-relative" style="height: 272px; ">
			<img src="static/img/banner1.jpg" class="banner-box" height="272" style="opacity: 0.4; ">
			<div class="pos-absolute" style="width: 500px; left: 10%; top: 45px;">
				<img src="static/img/logo.png" class="pos-absolute banner-box-logo width-100per">
			</div>
			<!-- 导航栏 -->
			<div class="per-line-50 red-b pos-absolute font-size-16 white width-100per" style="bottom: 10px;">
				<div style="width: 1200px; margin: 0 auto; " class="over-hidden">
					<div class="fl per-line-50 ellip tl c white" @click="goShopIndex()">首頁</div>
					<mu-menu class="fl per-line-50 tl c over-hidden white" style=" margin-left: 50px;" placement="bottom-start" open-on-hover :key='i' v-for="(category, i) in categorys">
						<div style="background-color: transparent;" class="fl per-line-50 ellip tl c white">{{ category.title }}</div>
						<mu-list slot="content" class="red-b white" :key='j' v-for="(categoryChild, j) in category.child">
							<mu-list-item button @click="goSortIndex(categoryChild.id, categoryChild.title)">
								<mu-list-item-title class="white">{{ categoryChild.title }}</mu-list-item-title>
							</mu-list-item>
						</mu-list>
					</mu-menu>
				</div>
			</div>
		</div>
		<!-- 公共头部 -->
		<!-- 最大的缩小 -->
		<div class="over-hidden white-b" style="min-height: 600px; width: 1200px; margin: 15px auto 0;">
			<!-- 最外层左边一栏 -->
			<div class="fl pad-15" style="width: 880px;">
				<div class="per-line-40 mar-bot-15">
					<select style="height: 30px; margin-top: 5px; " v-model='link_name' class="fl" @change='getAllHuiYuan()'>
						<option :value="linkCateList.id" v-for="linkCateList in linkCateLists">
							{{ linkCateList.title }}
						</option>
					</select>
				</div>
				<div :class="{'gray-b': i % 2 === 0}" v-for="(link, i) in links" class="c per-line-30 font-size-14 tl pad-lef-15" :key='i'>
					<span @click="goAdPage(link.url)">{{ link.name }}</span>
				</div>

				<mu-flex :class="{'display-block': isShowFenYe, 'display-none': !isShowFenYe, }" justify-content="center" style="margin: 32px 0 3px;">
					<mu-pagination raised :page-size="perPageNum" :total="tempAllSortsLength" :current.sync="currentPage" @change="getAnotherPage()"></mu-pagination>
				</mu-flex>

			</div>
			<div class="fl " style="width: 300px; margin-left: 20px; ">
				<!-- 广告位 写好了 -->
				<div class="per-little-cell"  :class="{'mar-top-15': j === 0}" v-for="(ad, j) in ads">
					<div class="pad-15 white-b">
						<img class="c" :src="ad.url | http" width="100%" @click="goAdPage(ad.weburl)">
					</div>
				</div>
			</div>
		</div>
		<!-- footer 内容 -->
		<div class="footer-box white-b over-hidden" style="margin: 50px auto 0; width: 1200px; ">
			<div class="fl tl font-size-12 pad-lef-15 pad-top-15 pad-bot-15" style="width: 880px; ">
				<div class="over-hidden">
					<div class="fl">關於我們</div>
					<div class="mar-lef-15 fl global-box" v-html="downAbout"></div>
				</div>
				<div class="over-hidden mar-top-5">
					<span class="fl">聯系我們</span>
					<span class="mar-lef-15 fl global-box" v-html="downContact"></span>
				</div>
				<div class="over-hidden mar-top-5">
					<span>免責申明</span>
					<span class="mar-lef-15">版權告示</span>
				</div>
			</div>
			<div class="fl pad-top-15 pad-rig-15 pad-bot-15" style="margin-left: 20px; width: 300px; ">
				<img src="static/img/logo2.jpeg" width="100%">
			</div>
		</div>
		<!-- footer 内容 -->
	</div>
</template>
<script>

export default {
	name: 'link_index',
	data () {
		return {
			link_id: '',

			// 分页器
			currentPage: 1, // 分页器当前显示的页数
			tempAllSortsLength: 0, // 总长度
			isShowFenYe: true, // 是否显示分页器
			perPageNum: 10, // 每页显示的条数

			// 一套
			categorys: [],
			ads: [],
			canShowRegister: false, // 是否显示登录页面
			showLoginBox: false, // 是否展示登录注册框

			// 友情链接
			linkCateLists: [],
			links: [],
			link_name: '',

			downContact: '',
			downAbout: '',

		}
	},
	created () {
		let that = this
		that.link_id = this.$route.query.link_id

		that.c_ajax({}, 'api.php/Link/cate_lists?visit=public', function (value) {
			if (value.data.status === 10001) {
				that.linkCateLists = []
				for (let v of value.data.data) {
					that.linkCateLists.push(v)
				}
				that.link_name = that.link_id
				that.getAllHuiYuan()
			}
		})

		// ------------------一套----------------
		// 获取导航栏分类
		that.c_ajax({}, 'api.php/CmsCategory/lists?visit=public', function (value) {
			for (let v of value.data) {
				// 活动1 讲座2 轮播图
				if (v.id !== 1 && v.id !== 2 && v.id !== 147) {
					that.categorys.push(v)
				}
			}
		})
		// 获取右边广告
		that.c_ajax({cate_id: 2}, 'api.php/Ad/lists?visit=public', function (value) {
			if (value.data.status === 10001) {
				for (let v of value.data.lists) {
					that.ads.push(v)
				}
			}
		})
		// 获得联系我们
		that.c_ajax({id: 2, }, 'api.php/Cms/detail?visit=public', function (value) {
			if (value.data.status === 10001) {

				that.downContact = value.data.detail.context
			}
		})
		// 获得关于我们
		that.c_ajax({id: 3, }, 'api.php/Cms/detail?visit=public', function (value) {
			if (value.data.status === 10001) {
				that.downAbout = value.data.detail.context
			}
		})
		// ------------------一套----------------
	},
	methods: {
		// 获取所有的
		getAllHuiYuan () {
			let that = this
			that.c_ajax({cate_id: that.link_name}, 'api.php/Link/lists?visit=public', function (value) {
				that.links = []

				if (value.data.status === 10001) {
					that.tempAllSortsLength = value.data.data.length
					if (that.tempAllSortsLength <= that.perPageNum) {
						that.isShowFenYe = false
					} else {
						that.isShowFenYe = true
					}
					that.currentPage = 1
					that.c_ajax({cate_id: that.link_name, num: that.perPageNum, p: 1, }, 'api.php/Link/lists?visit=public', function (value) {
						that.links = []
						if (value.data.status === 10001) {
							for (let v of value.data.data) {
								that.links.push(v)
							}
						}
					})
				}
			})
		},
		// 获取对应页数的数据
		getAnotherPage () {
			let that = this
			that.c_ajax({cate_id: that.link_name, num: that.perPageNum, p: that.currentPage, }, 'api.php/Link/lists?visit=public', function (value) {
				that.links = []
				if (value.data.status === 10001) {
					for (let v of value.data.data) {
						that.links.push(v)
					}
				}
			})
		},
		check_ruhuizhinan () {
			if (!this.userId) {
				this.showDialog('請先登錄!')
				return
			}
			if (this.userType === 2) {
				if (this.isShenHe) {
					this.showDialog('您已有企業，無需再次新建!')
					return
				}
				if (this.hasQiYe) {
					this.showDialog('您已新建企業，等待管理員審核通過!')
					return
				}
				this.goBusCompleteInfo()
			} else if (this.userType === 1) {
				if (this.isShenHe) {
					this.showDialog('您已入會，無需再次申請!')
					return
				}
				if (this.isRuHui) {
					this.showDialog('您已申請入會，等待管理員審核通過!')
					return
				}
				this.goUserCompleteInfo()
			}
		},
		check_huiyuanzhongxin () {
			if (!this.userId) {
				this.showDialog('請先登錄!')
				return
			}
			if (this.userType === 2) {
				if (!this.hasQiYe) {
					this.showDialog('您還沒有新建企業!')
					return
				}
				if (!this.isShenHe) {
					this.showDialog('還在審核中!')
					return
				}
				this.goBusIndex()
			} else if (this.userType === 1) {
				if (!this.isRuHui) {
					this.showDialog('您還沒入會，請申請入會!')
					return
				}
				if (!this.isShenHe) {
					this.showDialog('還在審核中!')
					return
				}
				this.goUserIndex()
			}
		},
		check_weiyuanhui () {
			if (!this.userId) {
				this.showDialog('請先登錄!')
				return
			}
			if (this.userType !== 3) {
				this.showDialog('您不是委員會用戶， 無法進入!')
				return
			}
			this.goWeiyuanIndex()
		},
		// 显示和隐藏会员注册
		showRegister () {
			let that = this
			that.canShowRegister = !that.canShowRegister
		},
		// 注册
		register () {
			let that = this
			if (!this.loginname) {
				this.showDialog('請輸入會員名稱!')
				return
			}
			if (!this.password) {
				this.showDialog('密碼不能為空!')
				return
			}
			if (!this.re_password) {
				this.showDialog('請再次輸入密碼!')
				return
			}
			if (this.re_password !== this.password) {
				this.showDialog('密碼不壹致!')
				return
			}
			let post = {
				loginname: this.loginname,
				password: this.password,
				re_password: this.re_password,
				type: this.type,
			}
			that.c_ajax({post: post}, 'api.php/Reg/reg?visit=public', function (value) {
				if (value.data.status === 10001) {
					that.showDialog('註冊成功!')
					that.showLoginBox = !that.showLoginBox
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 登录
		login () {
			let that = this
			if (!this.loginname) {
				this.showDialog('請輸入會員名稱!')
				return
			}
			if (!this.password) {
				this.showDialog('密碼不能為空!')
				return
			}
			let post = {
				loginname: this.loginname,
				password: this.password,
			}
			that.c_ajax({post: post}, 'api.php/Login/login?visit=public', function (value) {
				if (value.data.status === 10001) {
					that.showDialog('登錄成功!')
					// 登录成功后创建本地时间
					let locationDate = new Date().getTime()
					// 登录成功后 覆盖本地存储的数据
					that.setLocalObj('xianggangzhongxie', {
						user_id: value.data.user_id,
						token: value.data.token,
						token_time: locationDate,
						userType: value.data.type,
						isShenHe: value.data.isShenHe,
						isRuHui: value.data.is_ruhui,
						hasQiYe: value.data.is_ruhui,
					})
					// 本地存储更新后放入全局仓库
					that.$store.commit('updateUser', {
						user_id: that.getLocalObj('xianggangzhongxie').user_id,
						token: that.getLocalObj('xianggangzhongxie').token,
						token_time: that.getLocalObj('xianggangzhongxie').token_time,
					})

					that.$store.commit('updateUserType', {
						userType: that.getLocalObj('xianggangzhongxie').userType,
					})
					that.$store.commit('updateIsShenHe', {
						isShenHe: that.getLocalObj('xianggangzhongxie').isShenHe,
					})

					that.userType = that.$store.state.userType

					if (that.userType === 1) {
						that.$store.commit('updateIsRuHui', {
							isRuHui: that.getLocalObj('xianggangzhongxie').isRuHui,
						})
					} 
					if (that.userType === 2) {
						that.$store.commit('updateHasQiYe', {
							hasQiYe: that.getLocalObj('xianggangzhongxie').hasQiYe,
						})
					}
					// 再从仓库里面获取放入当前页面
					that.isRuHui = that.$store.state.isRuHui
					that.hasQiYe = that.$store.state.hasQiYe
					that.isShenHe = that.$store.state.isShenHe
					that.userId = that.$store.state.user_id


					that.canShowRegister = false
					that.loginname = ''
					that.password = ''
					that.re_password = ''
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 注册登录切换
		jumpLoginOrRegister () {
			this.loginname = ''
			this.password = ''
			this.re_password = ''
			this.showLoginBox = !this.showLoginBox
		},
		// getLink () {
		// 	let that = this
		// 	that.c_ajax({cate_id: that.link_name}, 'api.php/Link/lists?visit=public', function (value) {
		// 		that.links = []
		// 		if (value.data.status === 10001) {
		// 			for (let v of value.data.data) {
		// 				that.links.push(v)
		// 			}
		// 		}
		// 	})
		// },
	},
}
</script>

<style scoped>
.link_index {
}
</style>


// WEBPACK FOOTER //
// src/components/link_index.vue